import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useUserCreditDuration } from '../modules/apis/student/credit'
import { IScheduleResult } from '../modules/apis/student/lesson/schedule/queries'
import { useFeaturedTutorList } from '../modules/apis/student/tutors/recommend/useFeaturedTutorList'
import { useCurrentUser } from '../modules/context/UserContext'
import { COOKIE_LIST, COOKIE_OPT } from '../modules/vars'
import RecommendTutorPopup from './RecommendTutorPopup'
import RecommendTutorSchedulePopup from './RecommendTutorSchedulePopup'

function getRandomIndex(array) {
  const index = Math.floor(Math.random() * array.length)
  return index
}

interface InduceSchedulePopupProps {
  setResult: Dispatch<SetStateAction<IScheduleResult>>
  time?: number // seconds
}
const InduceSchedulePopup = ({ setResult, time = 3 }: InduceSchedulePopupProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const [duration, setDuration] = useState(null)
  const [currentTutor, setCurrentTutor] = useState(null)
  useUserCreditDuration({
    onSuccess: (data) => {
      setDuration(data)
    },
  })
  const { data } = useFeaturedTutorList(duration)
  const [showTutorTime, setShowTutorTime] = useState(false)
  const { currentUser } = useCurrentUser()
  const [cookies, setCookies] = useCookies([COOKIE_LIST.RECOMMEND_TUTOR_POPUP, 'startTime'])

  const setStartTimeCookie = () => {
    const now = new Date()
    const inThirtyMinutes = new Date(now.getTime() + 30 * 60 * 1000)
    setCookies('startTime', now.toISOString(), { ...COOKIE_OPT, expires: inThirtyMinutes })
  }

  useEffect(() => {
    if (data) {
      const randomIndex = getRandomIndex(data)
      const tutor = data[randomIndex]
      setCurrentTutor(tutor)
    }
  }, [data])

  useEffect(() => {
    if (cookies.recommend_tutor_popup !== 'true') {
      const timer = setTimeout(() => {
        setIsVisible(true)

        const expiration = new Date(Date.now() + 3600 * 1000 * 3)
        setCookies(COOKIE_LIST.RECOMMEND_TUTOR_POPUP, 'true', { ...COOKIE_OPT, expires: expiration })
        setStartTimeCookie()
      }, time * 1000)

      return () => clearTimeout(timer)
    }
  }, [cookies])

  useEffect(() => {
    if (showTutorTime) {
      setIsVisible(false)
    }
  }, [showTutorTime])

  if (currentUser?.upcoming_lesson_count > 0) return null
  if (!data) return null

  if (!currentTutor) return null

  return (
    <>
      {isVisible && (
        <RecommendTutorPopup
          isVisible={!showTutorTime && isVisible}
          // isVisible={true}
          onClose={() => setIsVisible(false)}
          // onClose={() => setIsVisible(true)}
          duration={10}
          tutor={currentTutor}
          setShowTutorTime={setShowTutorTime}
        />
      )}

      <RecommendTutorSchedulePopup
        tutor={currentTutor}
        showTutorTime={showTutorTime}
        setShowTutorTime={setShowTutorTime}
        setResult={setResult}
      />
    </>
  )
}

export default InduceSchedulePopup
